import { render } from "./goodrx-comparison-page.vue?vue&type=template&id=64b63762&scoped=true&ts=true"
import script from "./goodrx-comparison-page.vue?vue&type=script&lang=ts"
export * from "./goodrx-comparison-page.vue?vue&type=script&lang=ts"

import "./goodrx-comparison-page.vue?vue&type=style&index=0&id=64b63762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b63762"]])

export default __exports__